import React from 'react'; import ExtendedModulePage from './ExtendedModulePage'; export default function TransportAssignmentsPage(){return <ExtendedModulePage moduleKey="transport-assignments"/>}
